import { ErrorBus } from '~/features/error-bus';
import { isProdBuildMode } from '#shared/helpers/buildMode';

export default defineNuxtPlugin(() => {
  ErrorBus.onError((data) => {
    const error = data.e;
    error.name = `[ErrorBus] ${error.name}`;

    handleDevLogging(data);
  });

  function handleDevLogging(data: any) {
    if (isProdBuildMode()) return;

    console.log('%c [ErrorBus] \n', 'background-color: #d13100; color: white;', data);
  }
});
